<template>
  <BaseVeeForm
    :action="storeTag"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    class="space-y-8"
  >
    <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="isPending">
      <div class="mx-auto w-full max-w-lg">
        <BaseCard>
          <BaseCardHeader> Edit Tag </BaseCardHeader>
          <BaseCardBody class="space-y-4">
            <ValidationProvider rules="required" name="name" slim vid="name">
              <template #default="{ errors }">
                <BaseFormGroup>
                  <BaseFormLabel>Name</BaseFormLabel>
                  <BaseFormInput v-model="formData.name" />
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>

            <ValidationProvider rules="required" name="taggable by" slim vid="taggableBy">
              <template #default="{ errors }">
                <BaseFormGroup>
                  <BaseFormLabel>
                    Taggable by
                    <a role="button" href="#" @click.prevent="selectAllTaggables">select all</a>
                    <template v-if="formData.taggableBy.length > 0">
                      | <a role="button" href="#" @click.prevent="clearSelectedTaggables">clear</a>
                    </template>
                  </BaseFormLabel>
                  <div class="-mx-1">
                    <label
                      v-for="taggable in taggableByOptions"
                      :key="taggable"
                      :class="[
                        formData.taggableBy.indexOf(taggable) >= 0
                          ? 'border-transparent bg-blue-100 text-blue-800'
                          : 'border-gray-200 text-gray-800',
                      ]"
                      class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium border m-1"
                    >
                      <input
                        v-model="formData.taggableBy"
                        type="checkbox"
                        name="taggableBy"
                        :value="taggable"
                        :disabled="isPending"
                        class="hidden"
                      />
                      {{ taggable }}
                    </label>
                  </div>
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </BaseCardBody>
          <BaseCardFooter>
            <div class="flex space-x-2">
              <BaseButton primary :disabled="invalid || isPending"> Save </BaseButton>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="isPending"
                @click="$refs.modal.close()"
              >
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

const TAGGABLE_BY_ACCOUNTS = 'accounts';
const TAGGABLE_BY_CONTACT_REQUESTS = 'contact_requests';
const TAGGABLE_BY_CONTACTS = 'contacts';
const TAGGABLE_BY_PRODUCTS = 'products';
const TAGGABLE_BY_ASSETS = 'assets';
const TAGGABLE_BY_PAGES = 'pages';

export default {
  props: {
    action: {
      type: Function,
      required: true,
    },
    tag: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: this.tag?.name || '',
        taggableBy: this.tag?.taggableBy || [],
      },
      taggableByOptions: [
        TAGGABLE_BY_ACCOUNTS,
        TAGGABLE_BY_CONTACT_REQUESTS,
        TAGGABLE_BY_CONTACTS,
        TAGGABLE_BY_PRODUCTS,
        TAGGABLE_BY_ASSETS,
        TAGGABLE_BY_PAGES,
      ],
    };
  },
  methods: {
    clearSelectedTaggables() {
      this.formData.taggableBy = [];
    },
    selectAllTaggables() {
      this.formData.taggableBy = [...this.taggableByOptions];
    },
    async storeTag() {
      try {
        const response = await this.action(mapKeysToSnakeCase(this.formData));

        this.$emit('tag-updated', response.data);

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
